<template>
 <b-modal ref="modal" visible size="lg" :hide-footer="true" title="Bestellijst" @hidden="$emit('close')">
    <div v-if="orderList === null" class="text-center p-50">
      <i class="fa fa-spin fa-5x fa-spinner"></i>
    </div>

    <div v-else>
      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">
            Bestellijst: {{orderList.name}}
            <order-list-status-badge :orderList="orderList" class="ml-2" ref="orderListStatus" />
          </h3>
      </div>
      </div>

      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Producten</h3>
        </div>
        <div class="block-content p-0">
          <table ref="table" class="table table-borderless table-striped table-hover">
            <thead>
              <tr>
                <th></th>
                <th>Product</th>
                <th>Besteld</th>
                <th>Geleverd</th>
                <!-- <th v-if="status === 'delivered'">Geleverde aantal</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="line in orderList.lines" :key="line.id">
                <td>
                    <img v-if="line.product.image_urls" class="img-avatar img-avatar48" :src="line.product.image_urls[0]" alt="">
                    <i v-else  class="si si-picture  fa-2x"></i>
                </td>
                <td>{{line.product.name}}</td>
                <td>{{line.ordered_quantity}}</td>
                <td>
                  <!-- <div v-if="orderList.status === 'incomplete' || orderList.status === 'verify'" class="row">
                    <input v-model="deliveredAmounts[line.product_sku]" :id="line.id" ref="priceInput" type="number" class="form-control" style="width: 60px;">
                    <button type="submit" class="btn btn-success btn-noborder" @click="updateDeliveredAmount(line)">
                      <i class="fa fa-check"></i>
                    </button>
                    <p style="margin-left: 10px; font-size:larger;">van {{line.ordered_quantity || 'onbekend'}}</p>
                  </div> -->
                  <p>{{line.delivered_quantity}}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
        <button v-if="(status === 'ordered' || status === 'delivered') && user.role === 'admin'" type="submit" class="btn btn-success btn-noborder"  @click="updateStockQuantity()">
          Voorraad bijboeken <i class="fa fa-check"></i>
        </button>
    </div>
  </b-modal>
</template>

<script>
import http from '../utils/http'
import OrderListStatusBadge from './OrderListStatusBadge.vue'

export default {
  components: {
    OrderListStatusBadge
  },
  props: {
    orderListId: Number,
    status: String
  },
  data () {
    return {
      orderList: null,
      orderedAmounts: {},
      deliveredAmounts: {},
      user: this.$auth.getUser()
    }
  },
  methods: {
    loadOrderList () {
      const params = {
        include: 'lines,lines.product'
      }
      this.$api.getOrderList(this.orderListId, params)
        .then((result) => {
          this.orderList = result.data.data
          this.fillArrays(this.orderList.lines)
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Deze bestellijst konden we niet vinden. Probeer het opnieuw.', 'warning')
          this.$refs.modal.hide()
        })
    },
    fillArrays (lines) {
      lines.forEach(element => {
        this.$set(this.orderedAmounts, element.product_sku, element.ordered_quantity)
        this.$set(this.deliveredAmounts, element.product_sku, element.delivered_quantity)
      })
    },
    updateStockQuantity () {
      var validData = true
      for (const line of this.orderList.lines) {
        if (this.orderedAmounts[line.product_sku] < 0 || this.orderedAmounts[line.product_sku] === '') {
          validData = false
          this.$swal('Ehmm...', 'Alle producten moeten een geldige waarde hebben. Probeer het opnieuw.', 'warning')
          break
        }
      }
      if (validData) {
        const data = {
          orderListArray: this.orderedAmounts
        }
        http.patch(`/complete-order-list-lines/${this.orderList.id}`, data)
          .then((result) => {
            const statusData = {
              status: 'verify'
            }
            http.patch(`/order-list/${this.orderList.id}`, statusData)
              .then((response) => {
                this.$swal('Hoera 😊', `De bestellijst is sucessvol bijgeboekt.`, 'success')
                this.$refs.modal.hide()
              })
              .catch(() => {
                this.$swal('Ehmm...', 'Er is iets misgegaan bij het verwerken van deze bestellijst. Probeer het opnieuw.', 'warning')
              })
          })
          .catch(() => {
            this.$swal('Ehmm...', 'Er is iets misgegaan bij het verwerken van deze bestellijst. Probeer het opnieuw.', 'warning')
          })
      }
    },
    updateDeliveredAmount (line) {
      const data = {
        delivered_quantity: this.deliveredAmounts[line.product_sku],
        quantity_difference: this.deliveredAmounts[line.product_sku] - line.delivered_quantity
      }
      http.patch(`/update-delivered-quantity/${line.id}`, data)
        .then((result) => {
          this.$swal('Hoera 😊', `Het product is sucessvol bijgeboekt.`, 'success')
          this.loadOrderList()
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Er is iets misgegaan bij het verwerken van deze bestellijst. Probeer het opnieuw.', 'warning')
        })
    }
  },
  created () {
    this.loadOrderList()
  }
}
</script>

<style scoped>
a.disabled.block {
  cursor: not-allowed;
  opacity: 0.5;
}


</style>



// WEBPACK FOOTER //
// OrderedOrderListModal.vue?021f1e8e